import React from 'react'

const HistoryDisplay = () => {
    return (
        <div>
            History
        </div>
    )
}

export default HistoryDisplay
